import { getAppLogContext } from '~/services/app-interface';

const DEVICE_TYPE = {
  a: 'android',
  i: 'ios',
  m: 'mobile_web',
  w: 'pc_web',
} as const;

export const getEnvironmentInfo = () => {
  const deviceType = DEVICE_TYPE[getAppLogContext()?.device_type || 'w'];

  return {
    isWebview: !!getAppLogContext()?.app_id,
    deviceType,
    isIos: deviceType === 'ios',
    isAndroid: deviceType === 'android',
  } as const;
};
